import React from 'react';
import { useTranslation } from 'react-i18next';

import { formatDate } from '../utils';
import styles from '../styles.module.scss';

interface MapHeaderProps {
  title?: string;
  routeDistance: number | null;
  dateFrom: string;
  dateTo: string;
  itemsCount: number;
  sidebarOpen: boolean;
  onBack: () => void;
  onToggleSidebar: () => void;
  translationKeys: {
    back: string;
    templateMap: string;
  };
}

export const MapHeader: React.FC<MapHeaderProps> = ({
  title,
  routeDistance,
  dateFrom,
  dateTo,
  itemsCount,
  sidebarOpen,
  onBack,
  onToggleSidebar,
  translationKeys,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <button className={styles.backButton} onClick={onBack}>
        &larr; {t(translationKeys.back, 'Назад')}
      </button>
      <div className={styles.titleBlock}>
        <div className={styles.titleRow}>
          <h1 className={styles.title}>
            {title || t(translationKeys.templateMap, 'Карта маршрута')}
          </h1>
          {routeDistance !== null && (
            <span className={styles.headerDistance}>
              {routeDistance} {t('main.search.distance', 'км')}
            </span>
          )}
          {(dateFrom || dateTo) && (
            <span className={styles.headerDates}>
              {dateFrom && formatDate(dateFrom)}
              {dateFrom && dateTo && ' — '}
              {dateTo && formatDate(dateTo)}
            </span>
          )}
        </div>
      </div>
      <button className={styles.toggleSidebar} onClick={onToggleSidebar}>
        {sidebarOpen ? '✕' : '☰'} {sidebarOpen ? '' : `(${itemsCount})`}
      </button>
    </div>
  );
};
